<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/logo.png">
    <TimeLine msg="My timeline"/>
  </div>
</template>

<script>
import TimeLine from './components/TimeLine.vue'

export default {
  name: 'App',
  components: {
    TimeLine
  }
}
</script>

<style>
#app {
  margin: 0px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
